// extracted by mini-css-extract-plugin
module.exports = {"loginFormForm":"LoginForm_loginFormForm__mcbqI","loginButton":"LoginForm_loginButton__7hb0m","error":"LoginForm_error__257J7","formError":"LoginForm_formError__33jfm"};